<template>
  <div>
    <div class="kt-login__head">
      <div
        class="kt-header__topbar d-flex align-items-center justify-content-end cus-topbar"
      >
        <span>{{ $t("TRANSLATOR.SELECT") }}</span>
        <!--begin: Language bar -->
        <div class="kt-header__topbar-item kt-header__topbar-item--langs">
          <div
            class="kt-header__topbar-wrapper"
            id="kt_language_toggle"
            data-toggle="dropdown"
          >
            <span class="kt-header__topbar-icon">
              <img :src="languageFlag || defaultLanguageFlag" alt="" />
            </span>
          </div>

          <div
            class="dropdown-menu dropdown-menu-fit dropdown-menu-right"
            v-on:click.stop
          >
            <KTDropdownLanguage
              v-on:language-changed="onLanguageChanged"
            ></KTDropdownLanguage>
          </div>
        </div>
        <!--end: Language bar -->
      </div>
    </div>

    <!--begin::Body-->
    <div class="kt-login__body">
      <!--begin::Signin-->
      <div class="kt-login__form">
        <div class="kt-login__title">
          <h3>{{ $t("AUTH.LOGIN.TITLE") }}</h3>
        </div>

        <!--begin::Form-->
        <b-form class="kt-form" @submit.stop.prevent="onSubmit">
          <div
            role="alert"
            v-bind:class="{ show: errors && errors.length }"
            class="alert fade alert-danger"
          >
            <div class="alert-text" v-for="(error, i) in errors" :key="i">
              {{ error }}
            </div>
          </div>

          <b-form-group
            id="login-email-group"
            :label="$t('COMMON.USERNAME')"
            label-for="login-email"
          >
            <b-form-input
              id="login-email"
              name="login-email"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              aria-describedby="input-1-live-feedback"
            ></b-form-input>

            <b-form-invalid-feedback id="input-1-live-feedback">
              {{ $t("AUTH.VALIDATION.EMAIL") }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="login-password-group"
            :label="$t('AUTH.INPUT.PASSWORD')"
            label-for="login-password"
            class="mt-4"
          >
            <b-form-input
              type="password"
              id="login-password"
              name="login-password"
              v-model="$v.form.password.$model"
              :state="validateState('password')"
              aria-describedby="input-2-live-feedback"
            ></b-form-input>

            <b-form-invalid-feedback id="input-2-live-feedback">
              {{ $t("AUTH.VALIDATION.PASSWORD") }}
            </b-form-invalid-feedback>
          </b-form-group>

          <!-- Forgot password link belongs near password -->
          <div class="d-flex justify-content-end mt-2">
            <a
              href="#"
              class="kt-link kt-login__link-forgot"
              v-b-modal.forgot-modal
            >
              {{ $t("AUTH.FORGOT.TITLE") }}
            </a>
          </div>

          <!--begin::Action-->
          <div
            class="kt-login__actions d-flex align-items-center justify-content-between mt-4"
          >
            <b-button
              type="button"
              variant="link"
              class="p-0 kt-link"
              v-on:click="clearForm"
            >
              {{ $t("AUTH.CLEAR") }}
            </b-button>

            <b-button
              type="submit"
              id="kt_submit"
              class="btn btn-primary btn-elevate kt-login__btn-primary"
            >
              {{ $t("AUTH.LOGIN.BUTTON") }}
            </b-button>
          </div>
          <!--end::Action-->
        </b-form>
        <!--end::Form-->
      </div>
      <!--end::Signin-->

      <!-- ----------- twofa modal -->
      <b-modal
        id="twofa-modal"
        ref="twofa"
        :title="$t('TWOFA.TFAUTH')"
        @shown="onLoginOtpModalShown"
        @hidden="onLoginOtpModalHidden"
      >
        <b-container fluid>
          <b-alert show variant="info">
            {{ $t("AUTH.LOGIN.DESC4") }}
          </b-alert>
          <b-alert show variant="secondary">
            {{ $t("AUTH.LOGIN.DESC3") }}
          </b-alert>

          <b-row class="my-3">
            <b-col sm="12">
		<div class="otp-center">
              <label class="d-block mb-2" for="login-otp-0">
                {{ $t("AUTH.LOGIN.TFA") }}
              </label>

              <div class="otp-wrap" @paste.prevent="onLoginOtpPaste">
                <input
                  v-for="(d, idx) in loginOtpDigits"
                  :key="'login-otp-' + idx"
                  :id="'login-otp-' + idx"
                  :ref="'login-otp-' + idx"
                  class="otp-input"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  autocomplete="one-time-code"
                  maxlength="1"
                  :value="loginOtpDigits[idx]"
                  @input="onLoginOtpInput($event, idx)"
                  @keydown="onLoginOtpKeydown($event, idx)"
                  @focus="onLoginOtpFocus(idx)"
                  aria-label="2FA digit"
                />
              </div>

              <div v-if="loginOtpError" class="otp-error mt-2">
                {{ $t("VALIDATION.REQUIRED_FIELD") }}
              </div>
		</div>
            </b-col>
          </b-row>
        </b-container>

        <template v-slot:modal-footer>
          <b-button variant="outline-secondary" v-on:click="modalClose('twofa')">
            {{ $t("COMMON.CANCEL") }}
          </b-button>
          <b-button variant="primary" v-on:click="checkTwofa()">
            {{ $t("AUTH.LOGIN.BUTTON") }}
          </b-button>
        </template>
      </b-modal>
      <!--end::twofa-->

      <!-- ----------- forgot password modal -->
      <b-modal
        id="forgot-modal"
        ref="forgotPassword"
        :title="$t('AUTH.FORGOT.TITLE')"
      >
        <b-container fluid>
          <b-alert show variant="secondary">
            {{ $t("AUTH.FORGOT.DESC") }}
          </b-alert>
          <b-row class="my-3">
            <b-col sm="5">
              <label for="fusername">{{ $t("AUTH.INPUT.USERNAME") }}</label>
            </b-col>
            <b-col sm="7">
              <b-form-input
                id="fusername"
                v-model="$v.form.fusername.$model"
                :state="validateState('fusername')"
                :placeholder="$t('AUTH.INPUT.USERNAME')"
                aria-describedby="input-fusername-feedback"
              ></b-form-input>
              <b-form-invalid-feedback id="input-fusername-feedback">
                {{ $t("AUTH.VALIDATION.USERNAME") }}
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row class="my-3">
            <b-col sm="5">
              <label for="femail">{{ $t("AUTH.INPUT.EMAIL") }}</label>
            </b-col>
            <b-col sm="7">
              <b-form-input
                id="femail"
                v-model="$v.form.femail.$model"
                :state="validateState('femail')"
                :placeholder="$t('AUTH.INPUT.EMAIL')"
                aria-describedby="input-femail-feedback"
              ></b-form-input>
              <b-form-invalid-feedback id="input-femail-feedback">
                {{ $t("AUTH.VALIDATION.EMAIL") }}
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-container>
        <template v-slot:modal-footer>
          <b-button
            variant="outline-secondary"
            v-on:click="modalClose('forgotPassword')"
          >
            {{ $t("COMMON.CANCEL") }}
          </b-button>
          <b-button variant="primary" v-on:click="forgotPassword()">
            {{ $t("AUTH.FORGOT.SEND") }}
          </b-button>
        </template>
      </b-modal>
      <!-- ---------- change password modal end------------- -->
    </div>
    <!--end::Body-->
  </div>
</template>

<style lang="scss" scoped>
.kt-spinner.kt-spinner--right:before {
  right: 8px;
}

/* OTP UI (same feel as Twofa page) */

.otp-center {
  display: flex;
  flex-direction: column;
  align-items: center;     /* centers label + row */
  width: 100%;
}

.otp-wrap--center {
  justify-content: center; /* centers the 6 boxes row */
}

.otp-wrap {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.otp-input {
  width: 52px;
  height: 56px;
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #d6d6d6;
  border-radius: 8px;
  outline: none;
}

.otp-input:focus {
  border-color: #3699ff;
  box-shadow: 0 0 0 3px rgba(54, 153, 255, 0.2);
}

.otp-error {
  color: #f64e60;
  font-size: 13px;
}
</style>

<script>
import { mapState } from "vuex";
import { LOGIN_STEP1, LOGIN_STEP2 } from "@/store/auth.module";
import JwtService from "@/common/jwt.service";

import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";
import { postRequest } from "@/api/request.js";
import KTDropdownLanguage from "@/views/theme/topbar/DropdownLanguage.vue";
import i18nService from "@/common/i18n.service.js";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      form: {
        email: "",
        password: "",
        fusername: "",
        femail: "",
        token: "",
      },

      // login 2FA modal OTP
      loginOtpDigits: ["", "", "", "", "", ""],
      loginOtpError: false,
      loginOtpSubmitting: false,

      languageFlag: "",
      languages: i18nService.languages,
    };
  },
  components: {
    KTDropdownLanguage,
  },
  validations: {
    form: {
      email: {
        required,
        // email
      },
      password: {
        required,
        minLength: minLength(3),
      },
      fusername: {
        required,
      },
      femail: {
        required,
        email,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    onLanguageChanged() {
      const current = this.languages.find((val) => {
        return val.lang === i18nService.getActiveLanguage();
      });
      this.languageFlag = current ? current.flag : "";
    },

    modalClose(item) {
      this.form.fusername = null;
      this.form.femail = null;
      this.form.token = null;

      // reset OTP when closing 2FA modal
      if (item === "twofa") {
        this.resetLoginOtp();
      }

      this.$nextTick(() => {
        this.$v.$reset();
      });
      this.$refs[item].hide();
    },

    clearForm() {
      this.form.email = null;
      this.form.password = null;

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },

    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.email.$anyError || this.$v.form.password.$anyError) {
        return;
      }

      const username = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;

      // set spinner to submit button
      const submitButton = document.getElementById("kt_submit");
      submitButton.classList.add(
        "kt-spinner",
        "kt-spinner--light",
        "kt-spinner--right"
      );

      this.$store
        .dispatch(LOGIN_STEP1, {
          username,
          password,
          action: "adminlogin_step1",
        })
        .then((res) => {
          if (
            res.returncode == 1 &&
            !res.returndata.otprequired &&
            res.returndata.token
          ) {
            this.completeLogin(res.returndata.token);
          } else if (res.returndata.otprequired) {
            // show 2fa window
            this.form.token = res.returndata.token;
            this.$refs["twofa"].show();
          }
        })
        .finally(() => {
          submitButton.classList.remove(
            "kt-spinner",
            "kt-spinner--light",
            "kt-spinner--right"
          );
        });
    },

    completeLogin(token) {
      postRequest({
        action: "getAdminInfo",
        token: token,
      }).then((resUser) => {
        if (resUser && resUser.returncode) {
          JwtService.saveLoginUser(resUser.returndata.adminname);
          JwtService.saveTfaState(resUser.returndata.twofa_enabled);
          JwtService.saveTfaAllowedState(resUser.returndata.twofa_allowed);
          JwtService.saveSecurityWarningState(
            resUser.returndata.security_warning
          );
          JwtService.saveSecurityWarningLevel(
            resUser.returndata.security_warning_level
          );
          JwtService.saveUserRole(resUser.returndata.adminaccess);
          JwtService.saveTimeout(resUser.returndata.ui_timeout);
          JwtService.saveComplexPass(resUser.returndata.complexpass);
          JwtService.saveDomainsWithoutMx(resUser.returndata.domainswithoutmx);

          i18nService.setActiveLanguage(resUser.returndata.language);

          postRequest({
            action: "getPermissions",
            token: token,
          }).then((adminPermission) => {
            if (adminPermission && adminPermission.returncode) {
              JwtService.savePermission(adminPermission.returndata);
            }
            this.$router.push("home", () => this.$router.go(0));
          });
        }
      });
    },

    forgotPassword() {
      this.$v.form.$touch();
      if (this.$v.form.fusername.$anyError || this.$v.form.femail.$anyError) {
        return;
      }

      postRequest({
        action: "resetAdminPassword",
        username: this.form.fusername,
        emailadmin: this.form.femail,
      }).then((res) => {
        if (res.returncode) {
          this.makeToastVariant("success", res.returndata);
        } else {
          this.makeToastVariant("danger", res.returndata);
        }
        this.modalClose("forgotPassword");
      });
    },

    // ---------- Login 2FA OTP helpers ----------
    resetLoginOtp() {
      this.loginOtpDigits = ["", "", "", "", "", ""];
      this.loginOtpError = false;
      this.loginOtpSubmitting = false;
    },

    focusLoginOtp(idx) {
      this.$nextTick(() => {
        const el = this.$refs["login-otp-" + idx];
        const input = Array.isArray(el) ? el[0] : el;
        if (input && input.focus) input.focus();
        if (input && input.select) input.select();
      });
    },

    onLoginOtpModalShown() {
      this.resetLoginOtp();
      this.focusLoginOtp(0);
    },

    onLoginOtpModalHidden() {
      this.resetLoginOtp();
    },

    onLoginOtpFocus(idx) {
      const firstEmpty = this.loginOtpDigits.findIndex((d) => d === "");
      if (firstEmpty !== -1 && idx > firstEmpty) {
        this.focusLoginOtp(firstEmpty);
      }
    },

    onLoginOtpInput(e, idx) {
      const raw =
        e && e.target && e.target.value ? String(e.target.value) : "";
      const digit = raw.replace(/\D/g, "").slice(-1);

      this.$set(this.loginOtpDigits, idx, digit);
      this.loginOtpError = false;

      if (digit && idx < 5) {
        this.focusLoginOtp(idx + 1);
      }

      if (this.loginOtpDigits.every((d) => /^[0-9]$/.test(d))) {
        this.checkTwofa(); // auto-submit
      }
    },

    onLoginOtpKeydown(e, idx) {
      const key = e.key;

      if (key === "Backspace") {
        e.preventDefault();
        if (this.loginOtpDigits[idx]) {
          this.$set(this.loginOtpDigits, idx, "");
        } else if (idx > 0) {
          this.$set(this.loginOtpDigits, idx - 1, "");
          this.focusLoginOtp(idx - 1);
        }
        return;
      }

      if (key === "ArrowLeft" && idx > 0) {
        e.preventDefault();
        this.focusLoginOtp(idx - 1);
        return;
      }
      if (key === "ArrowRight" && idx < 5) {
        e.preventDefault();
        this.focusLoginOtp(idx + 1);
        return;
      }

      if (key.length === 1 && !/[0-9]/.test(key) && key !== "Tab") {
        e.preventDefault();
      }
    },

    onLoginOtpPaste(e) {
      const txt = (e.clipboardData && e.clipboardData.getData("text")) || "";
      const digits = String(txt).replace(/\D/g, "").slice(0, 6);
      if (!digits) return;

      const arr = digits.split("");
      for (let i = 0; i < 6; i++) {
        this.$set(this.loginOtpDigits, i, arr[i] || "");
      }

      if (digits.length === 6) {
        this.checkTwofa(); // auto-submit
      } else {
        this.focusLoginOtp(Math.min(digits.length, 5));
      }
    },

    clearLoginOtpAndRefocus() {
      this.loginOtpDigits = ["", "", "", "", "", ""];
      this.loginOtpError = false;
      this.$nextTick(() => this.focusLoginOtp(0));
    },

    checkTwofa() {
      if (this.loginOtpSubmitting) return;

      const complete = this.loginOtpDigits.every((d) => /^[0-9]$/.test(d));
      if (!complete) {
        this.loginOtpError = true;
        return;
      }

      this.loginOtpSubmitting = true;

      const username = this.$v.form.email.$model;
      const otpcode = this.loginOtpDigits.join("");
      const token = this.form.token;

      this.$store
        .dispatch(LOGIN_STEP2, {
          username,
          otpcode,
          token,
          action: "adminlogin_step2",
        })
        .then((res) => {
          if (res.returncode == 1 && res.returndata) {
            this.completeLogin(res.returndata);
          } else {
            this.makeToastVariant("danger", this.$t("AUTH.LOGIN.TFA_INVALID"));
            // UX improvement: clear & refocus on invalid code
            this.clearLoginOtpAndRefocus();
          }
        })
        .catch(() => {
          this.makeToastVariant("danger", this.$t("COMMON.ERROR"));
          this.clearLoginOtpAndRefocus();
        })
        .finally(() => {
          this.loginOtpSubmitting = false;
        });
    },

    /* ----notify---- */
    makeToastVariant(variant = null, msg) {
      let title = this.$t("COMMON.ERROR");
      if (variant == "success") {
        title = this.$t("COMMON.SUCCESS");
      }
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        toaster: "b-toaster-top-center",
        solid: true,
      });
    },
  },

  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),

    backgroundImage() {
      return process.env.BASE_URL + "assets/media/bg/bg-4.jpg";
    },

    defaultLanguageFlag() {
      const current = this.languages.find(
        (val) => val.lang === i18nService.getActiveLanguage()
      );
      return current ? current.flag : "";
    },
  },

  mounted() {
    // Ensure flag is correct on first render
    this.onLanguageChanged();
  },
};
</script>
